import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21a7c8d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-btn" }
const _hoisted_2 = {
  key: 0,
  "data-testid": "dropdown-filter-badge",
  class: "ml-1 rounded-full bg-primary5 px-1.5 text-[9px] font-bold text-primary30"
}
const _hoisted_3 = { class: "max-h-[285px] py-[16px] bg-white rounded-md" }
const _hoisted_4 = {
  key: 0,
  class: "flex gap-1 items-center w-full text-[16px] font-normal px-[16px] pb-[16px]"
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "text-[14px] scrolbar-filter overflow-y-scroll pl-[16px] pr-[8px] max-h-[190px] text-left w-full h-full flex flex-col items-center font-normal" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "block text-[11px] text-gray-400 font-normal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createBlock(_component_Popper, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.withSearch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                placeholder: `Buscar ${_ctx.title}`,
                class: "w-full px-3 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-primary",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event))
              }, null, 8, _hoisted_5), [
                [_vModelText, _ctx.searchValue]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsFiltered, (item) => {
            return (_openBlock(), _createElementBlock("span", {
              key: item.value,
              onClick: ($event: any) => (_ctx.$emit('clicked', item)),
              class: _normalizeClass([
              'w-full cursor-pointer p-[6px]',
              _ctx.isSelected(item.value)
                ? 'bg-gray-100 font-semibold text-primary30'
                : 'text-gray-700 hover:bg-gray-100'
            ])
            }, [
              _createTextVNode(_toDisplayString(item.title) + " ", 1),
              _renderSlot(_ctx.$slots, "item-trailing", { item: item }, undefined, true),
              (item.subtitle)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.subtitle), 1))
                : _createCommentVNode("", true)
            ], 10, _hoisted_7))
          }), 128))
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon))),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.title), 1),
          (_ctx.badge)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.badge), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 3
  }))
}